import React, { Component } from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function EngineBayDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Engine Bay Detailing',
    serviceType: 'Engine Bay Cleaning & Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks', 'Ventura County'],
    description: 'Professional mobile engine bay detailing in Ventura County. Safe degreasing, cleaning, and dressing of your engine compartment.'
  };
  const faqs = [{
    question: 'Is engine bay detailing safe for my car?',
    answer: 'Yes. We carefully protect sensitive electrical components and use low-pressure, controlled cleaning with appropriate degreasers. Our experienced technicians know exactly which areas to avoid, keeping your engine safe throughout the process.'
  }, {
    question: 'Why should I get my engine bay detailed?',
    answer: 'A clean engine bay makes it far easier to spot leaks and worn components, helps prevent grime buildup that traps heat, and dramatically improves resale value and presentation when selling your vehicle.'
  }, {
    question: 'How much does engine bay detailing cost in Ventura County?',
    answer: 'Engine bay detailing is often added to a full detail or booked on its own. Pricing depends on the size and condition of the engine bay. Call (818) 381-9905 for a quick quote.'
  }, {
    question: 'Do you come to me for engine bay detailing?',
    answer: 'Yes. Like all our services, engine bay detailing is fully mobile. We bring our own water, power, and products to your home or office anywhere in Ventura County.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Engine Bay Detailing',
    item: 'https://www.fulldetailpro.com/services/engine-bay-detailing'
  }];
  return <ServicePageLayout title="Engine Bay Detailing Ventura County" subtitle="Safe, professional engine bay cleaning that comes to you. Restore a clean, presentable engine compartment without risking sensitive components." metaDescription="Engine bay detailing in Ventura County. Safe mobile degreasing & cleaning of your engine compartment at your home or office. Call Mike's Pro Detail (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-572" data-mp="1iwcen72hu31j">
      <p data-id="element-573" data-mp="1xqgzgwquzyzf">
        A clean engine bay is the finishing touch on a truly detailed vehicle.
        Our <strong data-id="element-574" data-mp="1srcpi3w41x81">engine bay detailing in Ventura County</strong> safely
        removes years of grease, dust, and grime from your engine compartment,
        leaving it clean, presentable, and easier to maintain. We perform this
        service on-site as part of our mobile operation, serving Camarillo,
        Oxnard, Ventura, Thousand Oaks, and the surrounding communities.
      </p>

      <h2 data-id="element-575" data-mp="2xqj0g2p0yc9v">Our Engine Bay Detailing Process</h2>
      <p data-id="element-576" data-mp="2xrklmzzr8f5b">
        Engine bay cleaning requires care and experience. We protect sensitive
        electrical components, use controlled low-pressure rinsing, and apply
        the right products for each surface:
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-577" data-mp="3br3kf26oee4y">
        <li className="flex items-start" data-id="element-578" data-mp="3bqaluohveuxw">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-579" data-mp="3gq6punqkimdg" />
          <span data-id="element-580" data-mp="3goc4x9faqu9d">
            <strong data-id="element-581" data-mp="3gntxrhr3ivmo">Component Protection:</strong> We cover and protect exposed
            electrical connections and sensitive parts before any cleaning
            begins.
          </span>
        </li>
        <li className="flex items-start" data-id="element-582" data-mp="3qhswe6rynx9v">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-583" data-mp="3uicwnj7tzh08" />
          <span data-id="element-584" data-mp="3b0o1sl0kbvx">
            <strong data-id="element-585" data-mp="3aiig5cgolbc">Degreasing:</strong> Safe, effective degreasers break down
            built-up oil, grease, and road grime throughout the bay.
          </span>
        </li>
        <li className="flex items-start" data-id="element-586" data-mp="3hsc6urhp05nq">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-587" data-mp="3hrkncf1ddydt" />
          <span data-id="element-588" data-mp="3vkaawnwjrbd1">
            <strong data-id="element-589" data-mp="3vipestul3kd2">Detail Brushing & Rinsing:</strong> Hand brushing of tight
            areas followed by a controlled, low-pressure rinse.
          </span>
        </li>
        <li className="flex items-start" data-id="element-590" data-mp="32utkfvshm4jg">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-591" data-mp="32vuxu6wz734c" />
          <span data-id="element-592" data-mp="2yu00fdi619vu">
            <strong data-id="element-593" data-mp="2yujg0nkcfm6p">Dressing & Protection:</strong> A non-greasy dressing
            restores plastics and hoses to a clean, factory-fresh finish.
          </span>
        </li>
      </ul>

      <h2 data-id="element-594" data-mp="37twq9igakesh">Benefits of a Clean Engine Bay</h2>
      <p data-id="element-595" data-mp="37w971sabcj3y">
        Beyond looking great, a detailed engine bay makes it easier to identify
        leaks and worn components, helps prevent grime from trapping heat, and
        significantly boosts your vehicle's resale presentation. It's a smart
        addition to any{' '}
        <Link to="/services/full-car-detail" data-id="element-596" data-mp="250sjacvdte37">full car detail</Link>.
      </p>

      <h2 data-id="element-597" data-mp="2a0x2wbrl6oxn">Related Mobile Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-598" data-mp="29ykdxeneveb3">
        <Link to="/services/full-car-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-599" data-mp="1w2gorzre9w5h">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-600" data-mp="2sqwmij4nrbto">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/mobile-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-601" data-mp="2jx085qhqj3ot">
          Mobile Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-602" data-mp="3mbe0d9sq07co">
          Headlight Restoration &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}